import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M15 13H5l5-5z'],
  height: 20,
  width: 20,
});
